import { Injectable } from '@angular/core';
import {
  CompanyDebtorMinuteRequestResolutionDTO,
  FilterMinutes,
} from '../interface/minute-detail';

@Injectable({
  providedIn: 'root',
})
export class FilterMinuteService {
  constructor() {}
  public filterDealsOpportunities(
    fetchDealItems: Array<CompanyDebtorMinuteRequestResolutionDTO>,
    filters: string
  ): Array<CompanyDebtorMinuteRequestResolutionDTO> {
    let filteringDeals = [...fetchDealItems];
    console.log(filteringDeals);
    if (filters) {
      console.log(
        filters.replace(/\./g, '').replace('-', '').toLocaleLowerCase()
      );
      filteringDeals = filteringDeals.filter(
        (d) =>
          d.name.toLocaleLowerCase().includes(filters.toLocaleLowerCase()) ||
          d.fullRut.includes(filters)
      );
    }
    console.log(filteringDeals);

    // filteringDeals = filteringDeals.sort(sortFunction);
    return filteringDeals;
  }
}
